/*
 * Copyright 2022. NXGN Management, LLC. All Rights Reserved.
 */

export enum BusinessTypes {
  AutoRental = "Auto Rental",
  ECommerce = "eCommerce",
  Lodging = "Lodging",
  MOTO = "MOTO",
  Restaurant = "Restaurant",
  Retail = "Retail"
}
